module.exports = __webpack_public_path__ + "static/media/ProfessionalBrand.73b3a6e5.svg";